export default __webpack_public_path__ + "c397091c11742ae6a3a14cbd2622b262.png";